<div *ngIf="data">
  <ng-container ngSwitch="{{dialogType}}">

    <!--For Global Level-->

    <ng-container *ngSwitchCase="'globalLevel'">
      <div mat-dialog-content class="row createBgSubscription d-flex">

        <div class="row d-flex align-items-center px-3 w-100">
          <div class="padding-t10 padding-l20 col-2">
            <span class="text-uppercase font-weight-bold subText">SUBSCRIPTIONS</span>
          </div>
          <div class="padding-t10 col-10 d-flex align-items-center" *ngIf="data.isFavouriteOptionAvailable == true && data.selectedIndex == 0">
            <mat-checkbox style="vertical-align: text-top;" [color]="'primary'" [checked]="data.subscriptionList[0].isFavouriteChecked" (change)="onGlobalFavouriteCheckboxChange($event)">
            </mat-checkbox>&nbsp;&nbsp;
            <label class="m-0"><b>SEND ALERTS FOR ALL TRANSACTIONS FOR ALL ACCOUNTS.</b></label>
          </div>

          <div class="padding-t10 col-10" *ngIf="data.isFavouriteOptionAvailable == false || data.selectedIndex == 1">
          </div>

          <div class="col-2"></div>
          <div class="col-12">
            <hr />
          </div>
          <div class="row m-1 w-100" *ngIf="data.subscriptionList.length>=1 && data.subscriptionList[0].subscriptionTypeID!=null">
            <div class="col-4 p-0 setWidth" *ngFor="let subscription of data.subscriptionList">
              <div class="d-flex align-items-center">
                <mat-checkbox [color]="'primary'" [checked]="subscription.isServerSideChecked" [disabled]="subscription.isDisabled"
                              (change)="onCheckboxChange($event.checked,subscription)" class="example-margin">
                  <span matTooltip={{subscription.subscriptionType}} [matTooltipPosition]="'above'"
                        matTooltipClass="whiteFontSub">{{subscription.subscriptionType}}</span>
                </mat-checkbox>
                <span><i class="fas fa-info-circle" [title]="subscription.subscriptionDescription"></i></span>
              </div>
              <ng-container *ngIf="subscription.subscriptionTypeCode === 'CPP_ORDER_CONFIRMATION' && subscription.isServerSideChecked">
                <div class="subscriptionWrapper">
                  <mat-form-field class="subscriptionDropdown">
                    <mat-label>Add On Subscriptions</mat-label>
                    <mat-select [(ngModel)]="subscription.addOnSubscription" placeholder="Select"
                      panelClass="subscription-dropdown-panel"
                      (selectionChange)="onGlobalSubscriptionChange($event.value, subscription)" class="subscriptionSelectField">
                      <mat-option [value]="''"> </mat-option>
                      <mat-option value="Order Stoplight">Order Stoplight</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </ng-container>
              <ng-container *ngIf="subscription.subscriptionTypeCode !== 'CPP_ORDER_CONFIRMATION' && subscription.isSupplementSetupExist && subscription.isServerSideChecked">
                <div class="subscriptionWrapper">
                  <mat-form-field class="subscriptionDropdown">
                    <mat-label>Supplement Type</mat-label>
                    <mat-select [(ngModel)]="subscription.subscriptionSuplementId" (selectionChange)="onSupplementChange()" placeholder="Select" panelClass="subscription-dropdown-panel" class="subscriptionSelectField">
                      <mat-option *ngFor="let supplement of subscription.subscriptionSuplementList"
                                  [value]="supplement.id">
                        {{ supplement.value }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="col-12">
            <hr />
            <div class="row px-2 py-1">
              <div class="padding-10">
                <button mat-raised-button class="btns w-140" [disabled]="((data.subscriptionList.length==0) || (data.subscriptionList[0].subscriptionTypeID==null)) && data.isFavouriteOptionAvailable == false" [mat-dialog-close]="data.subscriptionList">Save</button>
              </div>
              <div class="padding-10">
                <button mat-raised-button class="btns w-140" (click)="onNoClick()">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </ng-container>

    <!--For Account Level-->

    <ng-container *ngSwitchCase="'accountLevel'">
      <div mat-dialog-content class="row createBgSubscriptionDetails">
        <div class="row">
          <div class="col-3 margin-10">
            <div><b>USER : </b> <span class="text-uppercase">{{data.subscriptionList.userName}}</span></div>
            <div><b> USER ID : </b> <span class="text-uppercase">{{data.subscriptionList.userID}}</span></div>
            <div><b>USER ROLE : </b> <span class="text-uppercase">{{data.subscriptionList.userRole}}</span></div>
          </div>
          <div class="col-4 margin-10">
            <div><b>ACCOUNT# : </b> <span class="text-uppercase">{{data.subscriptionList.accountNumber}}</span></div>
            <div><b>ACCOUNT : </b> <span class="text-uppercase">{{data.subscriptionList.accountName}}</span></div>
            <div><b>USER EMAIL : </b> <span class="text-uppercase">{{data.subscriptionList.emailAddress}}</span></div>
          </div>
        </div>
        <div class="col-12">
          <div class="row d-flex align-items-center w-100">
            <div class="padding-10 col-2">
              <span class="text-uppercase font-weight-bold subText">EDIT SUBSCRIPTIONS:</span>
            </div>
            <div class="padding-10 col-10 d-flex align-items-center" *ngIf="data.subscriptionList.isFavouriteOptionAvailable == true  && data.selectedIndex == 0">
              <mat-checkbox style="vertical-align: text-top;" [color]="'primary'" (change)="onFavouriteCheckboxChange($event)" [checked]="data.subscriptionList.isFavouriteChecked">
              </mat-checkbox>&nbsp;&nbsp;
              <label class="m-0">SEND ALERTS FOR ALL TRANSACTIONS.</label>
            </div>
            <div class="padding-10 col-10" *ngIf="data.subscriptionList.IsFavouriteOptionAvailable == false">
            </div>
          </div>
          <div class="row">

            <div class="col-12">
              <hr />
            </div>
          </div>

        </div>
        <div class="row m-1 w-100"
        *ngIf="data.subscriptionList.subscriptionList.length>=1 && data.subscriptionList.subscriptionList[0].subscriptionTypeID!=null">
          <div class="p-0 col-4 setWidth"
               *ngFor="let subscription of data.subscriptionList.subscriptionList">
            <div class="d-flex align-items-center">
              <mat-checkbox [color]="'primary'" [checked]="subscription.isServerSideChecked" [disabled]="subscription.isDisabled"
                            (change)="onCheckboxChange($event.checked,subscription)" class="example-margin">
                <span matTooltip={{subscription.subscriptionType}} [matTooltipPosition]="'above'"
                      matTooltipClass="whiteFontSub">{{subscription.subscriptionType}}</span>
              </mat-checkbox>
              <span><i class="fas fa-info-circle" [title]="subscription.subscriptionDescription"></i></span>
            </div>

            <ng-container *ngIf="subscription.subscriptionTypeCode === 'CPP_ORDER_CONFIRMATION' && subscription.isServerSideChecked">
              <div class="subscriptionWrapper">
                <mat-form-field class="subscriptionDropdown">
                  <mat-label>Add On Subscriptions</mat-label>
                  <mat-select [(ngModel)]="subscription.addOnSubscription" placeholder="Select"
                              panelClass="subscription-dropdown-panel"
                              (selectionChange)="onSubscriptionChange($event.value, subscription)" class="subscriptionSelectField">
                    <mat-option [value]="''"> </mat-option>
                    <mat-option value="Order Stoplight">Order Stoplight</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </ng-container>

            <ng-container *ngIf="subscription.subscriptionTypeCode !== 'CPP_ORDER_CONFIRMATION' && subscription.isSupplementSetupExist && subscription.isServerSideChecked">
              <div class="subscriptionWrapper">
                <mat-form-field class="subscriptionDropdown">
                  <mat-label>Supplement Type</mat-label>
                  <mat-select [(ngModel)]="subscription.subscriptionSuplementId" (selectionChange)="onSupplementChange()" placeholder="Select" panelClass="subscription-dropdown-panel" class="subscriptionSelectField">
                    <mat-option *ngFor="let supplement of subscription.subscriptionSuplementList"
                                [value]="supplement.id">
                      {{ supplement.value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </ng-container>
          </div>
      </div>
      </div>
      <div mat-dialog-actions>
        <button mat-raised-button class="btns w140" [disabled]="!isSaveEnabled" [mat-dialog-close]="data.subscriptionList">Save</button>
        <button mat-raised-button class="btns w140" (click)="onNoClick()">Cancel</button>
      </div>
    </ng-container>
  </ng-container>
</div>
